import { render, staticRenderFns } from "./AddRuleModal.vue?vue&type=template&id=1c5d2ce2&scoped=true&"
import script from "./AddRuleModal.vue?vue&type=script&lang=js&"
export * from "./AddRuleModal.vue?vue&type=script&lang=js&"
import style0 from "./AddRuleModal.vue?vue&type=style&index=0&id=1c5d2ce2&prod&lang=less&scoped=true&"
import style1 from "./AddRuleModal.vue?vue&type=style&index=1&id=1c5d2ce2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5d2ce2",
  null
  
)

export default component.exports